import { repository } from '@/api/base'

export default {
  async findById(id) {
    const { data } = await repository.get(`/employee/${id}`)
    return data
  }
}
